export default "__VITE_ASSET__5GnLJwbT__"